export function stringLiteralUnionField(opts) {
    return (value) => {
        if (value === undefined || value === null) {
            if (opts.required) {
                return {
                    isValid: false,
                    error: typeof opts.required === "object"
                        ? opts.required.message
                        : opts.message || "Field is required",
                };
            }
            return {
                isValid: true,
                value: undefined,
            };
        }
        if (typeof value !== "string") {
            return {
                isValid: false,
                error: opts.message || "Value must be a string",
            };
        }
        const stringValue = value;
        let isAllowed = false;
        if (opts.notStrict) {
            isAllowed = opts.allowedValues.includes(stringValue);
        }
        else {
            isAllowed = opts.allowedValues.some((allowedValue) => allowedValue.toLowerCase() === stringValue.toLowerCase());
        }
        if (!isAllowed) {
            return {
                isValid: false,
                error: opts.message ||
                    `Value must be one of: ${opts.allowedValues.join(", ")}`,
            };
        }
        return {
            isValid: true,
            value: stringValue,
        };
    };
}
